"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetProductInfoDialogProducts = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _api = require("../api");
var _useSWRFetch = require("./internal/useSWRFetch");
// istanbul ignore file @preserve -- api

const useGetProductInfoDialogProducts = ({
  productCodes
}) => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    data,
    error,
    fetch,
    isLoaded,
    isLoading
  } = (0, _useSWRFetch.useSWRFetch)({
    fallback: [],
    fetcher: async () => (0, _api.getProductInfoDialogProducts)({
      customerTypeId,
      graphQlUrl: graphQlNetUrl,
      productCodes,
      headers
    }),
    key: [graphQlNetUrl, ...productCodes],
    skip: loadingHeaders
  });
  return (0, _react.useMemo)(() => ({
    data,
    error,
    fetch,
    isLoaded: isLoaded && data.length > 0,
    isLoading
  }), [data, error, fetch, isLoaded, isLoading]);
};
exports.useGetProductInfoDialogProducts = useGetProductInfoDialogProducts;